module.exports = __webpack_public_path__ + "static/media/ad-classtab-mockup-below.6834a0f2.png";